import { baseApi } from '../../services/baseApi';
import { ApiEndPoints } from '../../constants/apiEndPoints';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  access: string;
  user: {
    id: number;
    full_name: string;
    email: string;
  };
}

export interface MeResponse {
  id: number;
  full_name: string;
  email: string;
  phone_number?: string;
  is_active?: boolean;
}

/** Auth endpoints (login + current user), injected into the shared baseApi. */
export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<LoginResponse, LoginRequest>({
      query: (body) => ({
        url: `${ApiEndPoints.access.login}/`,
        method: 'POST',
        body,
      }),
    }),
    getMe: build.query<MeResponse, void>({
      query: () => ({ url: `${ApiEndPoints.access.me}/` }),
    }),
  }),
});

export const { useLoginMutation, useGetMeQuery, useLazyGetMeQuery } = authApi;
